import React , {useState} from 'react'
import {  updateDoc  , collection, getFirestore, onSnapshot , doc} from 'firebase/firestore'
import { initializeApp } from 'firebase/app'
import Swal from 'sweetalert2';


function Delayed(targets , name) {
  const [showControls , setShowControls] = useState(false)

  const firebaseConfig = {
    apiKey: "AIzaSyDHYl0WYOlyq4fglpu3uZqV1LAuv6_5QvM",
    authDomain: "to-do-list-app-7aa20.firebaseapp.com",
    projectId: "to-do-list-app-7aa20",
    storageBucket: "to-do-list-app-7aa20.appspot.com",
    messagingSenderId: "388979404562",
    appId: "1:388979404562:web:e4df2225ac4d9b96408dcb"
  };
  initializeApp(firebaseConfig)

  // init services
  const db = getFirestore()
  // collection Ref
  const colRef = collection(db , `${window.localStorage.getItem("Name")}-targets`)
  
  const handleDelete = d => {
    console.log(d.progress , d.deleted)
    
    const docRef = doc(colRef , `${d.id}` )

    updateDoc(docRef , {
      delayed : false ,
      deleted : true
    });
    Swal.fire({
      position: 'center',
      imageUrl: 'https://thumbs.gfycat.com/NeatHollowAngelwingmussel-size_restricted.gif',
      imageWidth: 400,
      imageAlt: 'Custom image',
      showConfirmButton: false,
      // timer: 2500
      showCloseButton : true
    })
  }
  const handleFinished = f => {
    console.log(f.progress , f.deleted)
    
    const docRef = doc(colRef , `${f.id}` )

    updateDoc(docRef , {
      delayed : false ,
      finished : true
    });
    Swal.fire({
      position: 'center',
      imageUrl: 'https://thumbs.gfycat.com/EarnestSmartGrayreefshark-max-1mb.gif',
      imageWidth: 400,
      imageAlt: 'Custom image',
      showConfirmButton: false,
      showCloseButton : true
    })
  }
  
  return (
    <div className="notes delayedEle">
      <div className="container">
        <div className="content">
          <div className="top alert alert-info">
            <h1>Delayed Tasks</h1>
            {targets.targets.filter(f => f.delayed === true).length !== 0 && (
              <button className="controlSet" onClick={()=> setShowControls(!showControls)}>
                <img src="https://cdn-icons-png.flaticon.com/512/627/627495.png" alt="" title='control button' />
              </button>
            )}
          </div>
          {targets.targets.filter(f => f.delayed === true).length === 0 && 
            <div className="alerting unfinished">
              <div className="alert alert-secondary">
                <h3>No Task delayed </h3>
                <img src="https://thumbs.gfycat.com/OddballSoulfulIndianringneckparakeet-max-1mb.gif" alt="not delayed" />
              </div>
            </div>
          }
          <div className="bottom">
            {targets.targets.filter(f => f.delayed === true).map(p => (
              <div key={p.id} className="tab">
                <h3 dir='auto'>{p.Target}</h3>
                <p dir='auto'>{p.Description}</p>
                {showControls === true && (
                  <div className="options delay-opt" >
                    <div className="cont">
                      <button onClick={()=> handleDelete(p)}>
                        <img src="https://cdn-icons-png.flaticon.com/512/3221/3221897.png" alt="delete" />
                      </button>
                      <button onClick={()=> handleFinished(p)}>
                        <img src="https://cdn-icons-png.flaticon.com/512/214/214353.png" alt="done" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Delayed